module.exports = __webpack_public_path__ + "static/media/flux-capacitor.4a58592f.svg";